import React from "react";
import style from "./Sidebar.module.css";

interface Props {
  label?: string;
  children: React.ReactNode;
}

export function SidebarSection({ label, children }: Props) {
  return (
    <div className={style.sidebarSection}>
      {label && <span className={style.sidebarSectionHeader}>{label}</span>}
      {children}
    </div>
  );
}
